import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class EditScoreTypeForm {
  public label: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    label: [
      (v: string) => !!v || 'Label is required',
      (v: string) => v.length >= 3 || 'Label has to be at least 3 characters',
    ],
  };
}
